/**
 * Created by Jaap on 11-04-2018
 */

import Message from './Message';

export default class UserEvents{

     /**
     * EXAMPLE
     * sendEventUpdate('Video', 'Started', 'https://www.youtube.com/watch?v=MKbxyG12Cu8&t=441s')
     *
     * @param {string} type ('VIDEO', 'URL_CHANGE')
     * @param {string} action ('STARTED', 'OPENED')
     * @param {*} value ('http://lalasf.nl', 'popup1')
     * @param {object} spread_settings
     * @param {object} eventTarget
     */
    static sendEventUpdate( type, action, value, spread_settings, eventTarget ){
        const issue_id = spread_settings._spread_globals.issue_id
        const spread_id = spread_settings._spread_globals.spread_id
        const message = {
                message: 'USER_EVENT',
                // backwardcompatible
                type: type,
                action: action,
                label: value+' :: ('+issue_id+'|'+spread_id+')',
                value: issue_id,// this is a numeric value associated with the event
                // backwardcompatible
                dataGA3: {
                    type: type,
                    action: action,
                    label: value+' :: ('+issue_id+'|'+spread_id+')',
                    value: issue_id
                },
                dataGA4: {
                    type: type,
                    data: {
                        issue_id: issue_id,
                        spread_id: spread_id,
                        action: action,
                        label: value
                    }
                },
                layout: window.innerWidth < 501 ? 2 : 1
            }

        if (eventTarget) {
            message.dataGA4.data.element_name = eventTarget.dataset.label
            const split = eventTarget.id.split('_')
            message.dataGA4.data.screen_mode = parseInt(split.pop(), 10)
            message.dataGA4.data.element_id = split.pop()
        }

         Message.sendMessage(message, spread_id, issue_id);
    }
}
